import { Condition } from "./condition";

export class DisplayInfor {
    constructor(name:string, id: string) {
        this.name = name;
        this.activityDefinitionId = id;
        this.required = false;
    }
    name: string;
    activityDefinitionId: string;
    condition: string;
    required: boolean;
}

export class OtherAssignActivityNodeInfo {

    activityDefinitionId: string;
    condition: Condition;
    required: boolean;
    constructor(id: string, condition: string, required: boolean) {
        this.activityDefinitionId = id;
        this.condition = new Condition();
        this.condition.Value = condition;
        this.required = required;
    }
}